'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dDanger$002dAlert$0024$0024anon$002413 from "./presto.-Danger-Alert$$anon$13.js";
var $p;
/** @constructor */
function $c_Lpresto_DangerAlert$$anon$12() {
  this.aHR = null;
  this.aHP = null;
  this.aHQ = false;
  this.aHN = null;
  this.aHO = false;
  this.aHS = false;
  this.aHT = false;
  this.aHR = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_DangerAlert$$anon$12 as $c_Lpresto_DangerAlert$$anon$12 };
$p = $c_Lpresto_DangerAlert$$anon$12.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_DangerAlert$$anon$12;
/** @constructor */
function $h_Lpresto_DangerAlert$$anon$12() {
}
export { $h_Lpresto_DangerAlert$$anon$12 as $h_Lpresto_DangerAlert$$anon$12 };
$h_Lpresto_DangerAlert$$anon$12.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.aHR;
});
$p.t = (function() {
  if ((!this.aHQ)) {
    this.aHP = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("uef", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.aHQ = true;
  }
  return this.aHP;
});
$p.ae = (function() {
  if ((!this.aHO)) {
    this.aHN = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dDanger$002dAlert$0024$0024anon$002413.$c_Lpresto_DangerAlert$$anon$13(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.aHO = true;
  }
  return this.aHN;
});
$p.w = (function() {
  if ((!this.aHT)) {
    this.aHS = false;
    this.aHT = true;
  }
  return this.aHS;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_DangerAlert$$anon$12 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_DangerAlert$$anon$12, "presto.DangerAlert$$anon$12", ({
  Ge: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_DangerAlert$$anon$12 as $d_Lpresto_DangerAlert$$anon$12 };
//# sourceMappingURL=presto.-Danger-Alert$$anon$12.js.map
